import React, { Component } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { List, ListItem, ListItemText, Divider } from '@material-ui/core';
import { ChevronLeft } from '@material-ui/icons';
import {getEngineers} from '../services/user-service';

class EngineerList extends Component {
  constructor()
  {
    super();
    
    this.state = {
      engineers: []
    };
  }

  componentDidMount() {
    getEngineers().then((result) => { 
      this.setState({ engineers: result });
      this.props.onEngineersLoaded(result);
    });
  }

  close = () => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    this.props.onCancel();
  };

  selectEngineer = (engineer) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    this.props.onSelect(engineer);
  };

  render() {
    return (
      <Drawer anchor={'top'} open={this.props.isOpen} onClose={this.close()}>
        <List>
          <ListItem button onClick={this.close()}>
            <ChevronLeft/>
          </ListItem>
          <Divider/>
          {this.state.engineers?.map((engineer) => (
            <ListItem button key={engineer.id} onClick={this.selectEngineer(engineer)}>
              <ListItemText primary={engineer.fullName}/>
            </ListItem>
          ))}
        </List>
      </Drawer>
    );
  }
}

export default EngineerList